import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import { useHistory } from 'react-router-dom'

export const PageNotFound = () => {
  const classes = useStyles()
  const history = useHistory()

  return (
    <div className={classes.root}>
      <div className={classes.title}>404</div>
      <div className={classes.subtitle}>Page not found</div>
      <div className={classes.body}>We are sorry, but the page you are looking for is unavailable.</div>
      <Button
        className={classes.goBack}
        color='primary'
        onClick={() => {
          history.push('/event')
        }}
      >
        Go Back
      </Button>
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    fontFamily: 'Verizon-Regular',
    color: '#000',
    backgroundColor: '#fff',
    padding: '4rem'
  },
  title: {
    fontSize: 100,
    fontFamily: 'Verizon-Bold',
    lineHeight: 1
  },
  subtitle: {
    fontSize: 40,
    fontFamily: 'Verizon-Bold',
    marginBottom: 12
  },
  body: {
    fontSize: 20,
    textAlign: 'center'
  },
  goBack: {
    color: '#000',
    textDecoration: 'underline !important',
    fontFamily: 'Verizon-Regular',
    textTransform: 'capitalize',
    fontSize: 20
  }
}))
